'use client';

import { markdownTrilogy } from '@bytel/markdown-trilogy';
import { Button, Image, Modal, Title, TitleLevels, TypographyColor, View } from '@bytel/trilogy-react-ts';

import { FaiProduct } from '@app-types/fai';

import { Cms } from '@components/cms';

const FaiDetailsModal = ({
    onClose,
    active,
    faiOffer,
}: {
    onClose: () => void;
    active: boolean;
    faiOffer?: FaiProduct;
}) => {
    return (
        <Modal closeIcon active={active} onClose={onClose} className='otis-modal'>
            <View className='otis-modal-content'>
                <Title level={TitleLevels.TWO} className=''>
                    {faiOffer?.modal_title || faiOffer?.title || 'Détails de l’offre'}
                </Title>
                <View>
                    {faiOffer?.modal_subtitle && (
                        <Title level={TitleLevels.THREE} typo={TypographyColor.TEXT_TERTIARY}>
                            {faiOffer?.modal_subtitle}
                        </Title>
                    )}
                    {faiOffer?.modal_image?.public_url && (
                        <View className='mb-4 mt-4 img-cover'>
                            <Image src={faiOffer.modal_image.public_url} alt={faiOffer.modal_title} />
                        </View>
                    )}
                    {faiOffer?.modal_content && <Cms content={markdownTrilogy(faiOffer.modal_content)} />}
                </View>
            </View>

            <View className='mt-4'>
                <Button className='is-primary oisBg is-fullwidth has-byou-background' onClick={onClose}>
                    Fermer
                </Button>
            </View>
        </Modal>
    );
};

export default FaiDetailsModal;
